export default __webpack_public_path__ + "static/media/shopeepay_coming_soon.3485fae0.png";